import React from 'react';
import Layout from '../layouts/two';
import Tournament from './partials/tournament';
import moment from 'moment';
import _ from 'lodash';
import { Animated } from "react-animated-css";
import { Link } from 'react-router';

// August 6th: refactored for responsiveness
class PastTournaments extends React.Component {
    state = {
        year: parseInt(moment().format('YYYY'), 10)
    }
    componentWillMount() {
        const { tournamentsActions, past } = this.props;
        if (past) {
            this.setState({ past: _.chain(past).groupBy('Grouping').values().value() });
        } else tournamentsActions.fetchPast();
    }
    componentWillReceiveProps = nextProps => {
        const { past } = nextProps;
        this.setState({ past: _.chain(past).groupBy('Grouping').values().value() });
    }
    addYear = i => {
        const { year } = this.state;
        if (parseInt(moment().format('YYYY'), 10) === year && i > 0) return;
        else {
            this.setState({ year: parseInt(moment(year, 'YYYY').add(i, 'years').format('YYYY'), 10) });
        }
    }

    render() {
        const { past, year } = this.state;
        const filteredPast = _.filter(past || [], group => parseInt(moment(_.first(group).DateStart).format('YYYY'), 10) === year);
        return <Layout nbs="tournaments" title="PAST TOURNAMENTS" bi="/images/backgrounds/3balls.jpg">
            <section>
                <div id="tournaments">
                    <div className="w3-container w3-content margin-bottom-double">
                        <div style={{ height: 20 }} />
                        {past && <Animated animationIn="fadeInLeft" animationInDelay={1000} className="d-flex flex-row">
                            <div className="d-flex flex-row align-self-center">
                                <button className="btn btn-link" onClick={() => this.addYear(-1)}><i className="fas fa-arrow-left white"></i></button>
                                <button onClick={this.toggleYear} className="w3-button dark text-left d-flex flex-row white">{year}</button>
                                <button className="btn btn-link" onClick={() => this.addYear(1)}><i className="fas fa-arrow-right white"></i></button>
                            </div>
                            <Link to="/tournaments" className="white ml-auto align-self-center">UPCOMING TOURNAMENTS</Link>
                        </Animated>}
                        <div className="d-flex flex-column">
                            {past && filteredPast.reverse().map((group, i) => <section key={i}>
                                <h3 className="white margin-top-double hind">{moment(_.first(group).DateStart).format('MMMM YYYY')}</h3>
                                <ul className="no-margin no-padding" style={{ listStyle: 'none' }}>
                                    {_.orderBy(group, 'DateStart').map((t, j) => <Animated key={t.id} animationIn="fadeInLeft" component="li" className="w3-card margin-top"
                                        style={{ backgroundColor: 'white', borderRadius: 4 }}>
                                        <Tournament tournament={t} />
                                    </Animated>)}
                                </ul>
                            </section>)}
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    }
}

export default PastTournaments;



// WEBPACK FOOTER //
// ./src/components/tournaments/past.js